// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.logo-img[data-v-ff88e376] {\n  margin-bottom: 8px;\n  width:45px;\n}\n", ""]);
// Exports
module.exports = exports;
